import Icon from "@ant-design/icons";

const Svg = () => {
  return (
    <svg width="63" height="63" viewBox="0 0 63 63" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_9312_8177)">
<rect width="63" height="63" rx="31.5" fill="white"/>
<rect x="-1" width="64" height="64" fill="#EDEEF0"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M31.0008 32C35.2963 32 38.7778 28.4174 38.7778 23.9992C38.7778 19.581 35.2963 16 31.0008 16C26.7054 16 23.2223 19.581 23.2223 23.9992C23.2078 28.4024 26.6667 31.9851 30.946 32H31.0008Z" stroke="#68727D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M31.0009 36.8C23.4491 36.8 17 37.9149 17 42.38C17 46.8451 23.4082 48 31.0009 48C38.5528 48 45 46.8833 45 42.42C45 37.9567 38.5937 36.8 31.0009 36.8Z" stroke="#68727D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
</g>
<defs>
<clipPath id="clip0_9312_8177">
<rect width="63" height="63" rx="31.5" fill="white"/>
</clipPath>
</defs>
</svg>

  )
}
export const MyIcon = (props: any) => <Icon component={Svg} {...props} />;